import MediaQueryDispatch from "./MediaQueryDispatch";
export default MediaQueryDispatch;
